import { fork } from 'redux-saga/effects';
import { watchCrudResource } from './common/crudResource';

export default [
  fork(watchCrudResource),
];
